"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6123],{

/***/ 56123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SkipNavigationBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40483);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8996);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24036);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);





function SkipNavigationBlock(props) {
  var block = new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(props);
  var label = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_3__/* .SkipNavigationBlockConstants.label */ .oW.label);
  var targetID = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_3__/* .SkipNavigationBlockConstants.targetID */ .oW.targetID);

  var goToContent = function goToContent(event) {
    if (targetID !== '' && document.getElementById(targetID) !== null) {
      return;
    }

    event.preventDefault();
    var mainContent = document.querySelector(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_3__/* .SkipNavigationBlockConstants.roleMain */ .oW.roleMain);
    (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_2__/* .focusOnElement */ .dj)(mainContent);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
    "aria-label": label.fields.text,
    onClick: function onClick(event) {
      return goToContent(event);
    },
    className: 'visually-hidden ob-skip-navigation',
    href: "#".concat(targetID),
    children: label.fields.text
  });
}

/***/ })

}]);